import React from 'react';
import ReactDOM from 'react-dom';
import View from './forgotPassword/ResetPasswordView.jsx';

export default ({
  element,
  props,
}) => {
  ReactDOM.render(
    <View {...props} />,
    element
  );
};
